import ManagerContentWrapper from './ManagerContentWrapper'

export default ManagerContentWrapper
